import { render, staticRenderFns } from "./card-item.vue?vue&type=template&id=611f3afe&scoped=true"
import script from "./card-item.vue?vue&type=script&lang=js"
export * from "./card-item.vue?vue&type=script&lang=js"
import style0 from "./card-item.vue?vue&type=style&index=0&id=611f3afe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611f3afe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('611f3afe')) {
      api.createRecord('611f3afe', component.options)
    } else {
      api.reload('611f3afe', component.options)
    }
    module.hot.accept("./card-item.vue?vue&type=template&id=611f3afe&scoped=true", function () {
      api.rerender('611f3afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/container-widget/card-item.vue"
export default component.exports